import { post } from 'service/http';
import { Component, Vue } from 'vue-property-decorator';
import { CommonRes } from 'src/types/views/common';

@Component
export default class InitFavorData extends Vue {
  loading = true;

  data: any[] = [];

  pageNum = 1;

  pageSize = 10;

  total = 0;

  url = '';

  time = 50;

  params = {};

  wholews = '0';

  keyword = '';

  pageSizes = [10, 20, 50, 100, 200];

  async init() {
    if (!await this.beforeInit()) {
      return false;
    }
    return new Promise((resolve, reject) => {
      this.loading = true;
      post(this.url, this.params)
        .then((res) => {
          if ((res as CommonRes<any>).code === 200) {
            this.afterInit(res as CommonRes<any>);
            setTimeout(() => {
              this.loading = false;
            }, this.time);
            resolve();
          } else {
            this.$notify.error((res as CommonRes<any>).msg || '接口异常');
          }
        })
        .catch((err) => {
          this.loading = false;
          reject(err);
        });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  beforeInit() {
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  afterInit(res: CommonRes<any>) {
    return true;
  }

  // 预防删除第二页最后一条数据时，或者多选删除第二页的数据时，页码错误导致请求无数据
  delChangePage(size = 1) {
    if (this.data.length === size && this.pageNum !== 1) {
      this.pageNum -= 1;
    }
  }

  pageChange(e: number) {
    this.pageNum = e;
    this.init().then(() => {
      window.scrollTo(0, 0);
    });
  }

  sizeChange(e: number) {
    this.pageNum = 1;
    this.pageSize = e;
    this.init().then(() => {
      window.scrollTo(0, 0);
    });
  }

  toQuery() {
    this.pageNum = 1;
    this.init();
  }

  mounted() {
    this.init();
  }
}
